import * as React from 'react';
import MonthNavigation from '../../custom/components/month-navigation/month-navigation';
import { ListMonthProps } from '../../components/list/month';
import ListDay from '../../components/list/day';

const ListMonthView: React.StatelessComponent<ListMonthProps> = props => {
    const hasEvents = props.monthData.events.allDays.length > 0;
    function listWithEvents() {
        return (
            <>
                <ul className="ace-cal-list-days" aria-labelledby={`Month-List-${props.monthData.monthMoment.format("X")}`}>
                    {
                        props.monthData.events.allDays.map(day => <ListDay key={day.date.toDateString()} day={day} />)
                    }
                </ul>
            </>
        );
    }
    function listWithNoEvents() {
        return (
            <>
                <div className="ace-cal-list-days-empty" dangerouslySetInnerHTML={{ __html: props.text.emptyMonthMessage }} aria-labelledby={`Month-List-${props.monthData.monthMoment.format("X")}`}></div>
            </>
        );
    }

    function list() {
        if (hasEvents) {
            return listWithEvents()
        }
        else {
            return listWithNoEvents()
        }
    }
    return (
        <li className="ace-cal-list-month">
            <article>
                <div className="ace-cal-list-month-name-container">
                    <h3 id={`Month-List-${props.monthData.monthMoment.format("X")}`} className="ace-cal-list-month-name">{props.monthData.monthMoment.format("MMMM YYYY")}</h3>
                    <MonthNavigation />
                </div>
                {list()}
            </article>
        </li>
    );
}

export default ListMonthView;